import { IrisBase } from '@/models/iris/IrisBase'
import { ICoriolisEnable, getDefaultCoriolisEnable } from './ICoriolisEnable';
import { ICoriolisExport, getDefaultCoriolisExport } from './ICoriolisExport';

export interface ICoriolisConfig extends IrisBase {
    EnabledMOD:ICoriolisEnable,
    Coriolis_Export:ICoriolisExport
} 

export const getDefaultCoriolisConfig = ():ICoriolisConfig => {
    return {        
        Coriolis_Export:getDefaultCoriolisExport(),
        EnabledMOD:getDefaultCoriolisEnable()
    }
}